import React from 'react';
import Icon from '../../../components/AppIcon';

const ActivityItem = ({ type, client, value, stage, date, time }) => {
  const getActivityIcon = () => {
    switch (type) {
      case 'deal_moved':
        return 'ArrowRight';
      case 'deal_won':
        return 'CheckCircle2';
      case 'deal_lost':
        return 'XCircle';
      case 'appointment':
        return 'Calendar';
      case 'delivery':
        return 'Package';
      default:
        return 'Activity';
    }
  };

  const getActivityColor = () => {
    switch (type) {
      case 'deal_won':
        return 'text-success';
      case 'deal_lost':
        return 'text-destructive';
      case 'appointment':
        return 'text-secondary';
      case 'delivery':
        return 'text-warning';
      default:
        return 'text-primary';
    }
  };

  const getActivityText = () => {
    switch (type) {
      case 'deal_moved':
        return `Deal moved to ${stage}`;
      case 'deal_won':
        return 'Deal closed successfully';
      case 'deal_lost':
        return 'Deal marked as lost';
      case 'appointment':
        return 'Upcoming appointment';
      case 'delivery':
        return 'Delivery scheduled';
      default:
        return 'Activity recorded';
    }
  };

  return (
    <div className="flex items-start gap-3 md:gap-4 p-3 md:p-4 rounded-xl hover:bg-muted/50 transition-smooth">
      <div className={`w-10 h-10 md:w-12 md:h-12 rounded-lg bg-muted flex items-center justify-center flex-shrink-0 ${getActivityColor()}`}>
        <Icon name={getActivityIcon()} size={20} />
      </div>
      <div className="flex-1 min-w-0">
        <div className="flex items-start justify-between gap-2 mb-1">
          <h4 className="font-medium text-sm md:text-base text-foreground truncate">{client}</h4>
          {value && (
            <span className="text-sm md:text-base font-semibold text-foreground whitespace-nowrap">₹{value?.toLocaleString()}</span>
          )}
        </div>
        <p className="text-xs md:text-sm text-muted-foreground mb-1">{getActivityText()}</p>
        <div className="flex items-center gap-2 text-xs text-muted-foreground">
          <Icon name="Clock" size={12} />
          <span>{date} at {time}</span>
        </div>
      </div>
    </div>
  );
};

export default ActivityItem;